var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { takeEvery, takeLatest, takeLeading } from 'redux-saga/effects';
import * as actions from '../constants/actionTypes';
import callApi from '../graphql/callApi';
import sagaFactory from '../utils/sagaFactory';
export var getTrips = sagaFactory('getTrips', actions.getTrips, callApi.getTrips, 'trips', {
    delay: 300,
});
export var getRoutes = sagaFactory('getBaseRoutes', actions.getRoutes, callApi.getRoutes, 'getBaseRoutes', {
    delay: 300,
});
export var getRoute = sagaFactory('route', actions.getRoute, callApi.getRoute, 'route', {
    delay: 300,
});
export var modifyRoute = sagaFactory('modifyRoute', actions.modifyRoute, callApi.modifyRoute, 'modifyRoute');
export var createDriverReliability = sagaFactory('createDriverReliability', actions.createDriverReliability, callApi.createDriverReliability, 'createDriverReliability');
export var getTripsPage = sagaFactory('getTripsPage', actions.getTripsPage, callApi.getTripsPage, 'trips', {
    delay: 300,
});
export var getAuditsPage = sagaFactory('getAuditsPage', actions.getAuditsPage, callApi.getAuditsPage, 'trips', {
    delay: 300,
});
export var getUsersByDate = sagaFactory('getUsersByDate', actions.getUsersByDate, callApi.getUsersByDate, 'usersByDate', {
    delay: 300,
});
export var getUsers = sagaFactory('getUsers', actions.getUsers, callApi.getUsers, 'usersBySearch', {
    delay: 300,
});
export var getUsersForSavers = sagaFactory('getUsersForSavers', actions.getUsersForSavers, callApi.getUsersForSavers, 'usersBySearch', {
    delay: 300,
});
export var getAddressValidationFeedback = sagaFactory('getAddressValidationFeedback', actions.getAddressValidationFeedback, callApi.getAddressValidationFeedback, 'getAddressValidationFeedback');
export var getDrivers = sagaFactory('getDrivers', actions.getDrivers, callApi.getDrivers, 'drivers');
export var processScan = sagaFactory('processScan', actions.processScan, callApi.processScan, 'processScan');
export var deleteScan = sagaFactory('deleteScan', actions.deleteScan, callApi.deleteScan, 'deleteScan');
export var processQRCodeScan = sagaFactory('processQRCodeScan', actions.processQRCodeScan, callApi.processQRCodeScan, 'processQRCodeScan');
export var processPolybagScan = sagaFactory('processPolybagScan', actions.processPolybagScan, callApi.processPolybagScan, 'processPolybagScan');
export var updateTrip = sagaFactory('updateTrip', actions.updateTrip, callApi.updateTrip, 'updateTrip');
export var deletePickup = sagaFactory('deletePickup', actions.deletePickup, callApi.deleteTrip, 'deleteTrip');
export var getRetailers = sagaFactory('getRetailers', actions.getRetailers, callApi.getRetailers, 'retailers');
export var getCarriers = sagaFactory('getCarriers', actions.getCarriers, callApi.getCarriers, 'carriers');
export var createRetailer = sagaFactory('createRetailer', actions.createRetailer, callApi.createRetailer, 'createRetailer');
export var sendComms = sagaFactory('sendComms', actions.sendComms, callApi.sendComms, 'sendComms');
export var createTripMedia = sagaFactory('createTripMedia', actions.createTripMedia, callApi.createTripMedia, 'createTripMedia');
export var deleteTripMedia = sagaFactory('deleteTripMedia', actions.deleteTripMedia, callApi.deleteTripMedia, 'deleteTripMedia');
export var getDashboardData = sagaFactory('getDashboardData', actions.getDashboardData, callApi.getDashboardData, 'dashboard');
export var getPartners = sagaFactory('getPartners', actions.getPartners, callApi.getPartners, 'partners');
export var getPartnersForSavers = sagaFactory('getPartnersForSavers', actions.getPartnersForSavers, callApi.getPartnersForSavers, 'partners');
export var createPartnerUser = sagaFactory('createPartnerUser', actions.createPartnerUser, callApi.createPartnerUser, 'createPartnerUser');
export var getTripSummary = sagaFactory('getTripSummary', actions.getTripSummary, callApi.getTripSummary, 'tripSummary');
export var getPackageSummary = sagaFactory('getPackageSummary', actions.getPackageSummary, callApi.getPackageSummary, 'packageSummary');
export var getOnfleetWorkers = sagaFactory('getOnfleetWorkers', actions.getOnfleetWorkers, callApi.getOnfleetWorkers, 'onfleetWorkers', {
    delay: 300,
});
export var getOnfleetWorkersForRoutes = sagaFactory('getOnfleetWorkersForRoutes', actions.getOnfleetWorkersForRoutes, callApi.getOnfleetWorkersForRoutes, 'onfleetWorkers', {
    delay: 300,
});
export var getDummyDriversByHubId = sagaFactory('getDummyDriversByHubId', actions.getDummyDriversByHubId, callApi.getDummyDriversByHubId, 'getDummyDriversByHubId');
export var getRole = sagaFactory('getRole', actions.getUserRole, callApi.userRole, 'userRole');
export var updateRole = sagaFactory('updateRole', actions.updateUserRole, callApi.updateUserRole, 'updateRole');
export var removeUserHub = sagaFactory('removeUserHub', actions.removeUserHub, callApi.removeUserHub, 'removeUserHub');
export var addUserToHub = sagaFactory('addUserToHub', actions.addUserToHub, callApi.addUserToHub, 'addUserToHub');
export var togglePartner = sagaFactory('togglePartner', actions.togglePartner, callApi.togglePartner, 'togglePartner');
export var updatePartner = sagaFactory('updatePartner', actions.updatePartner, callApi.updatePartner, 'updatePartner');
export var createPartner = sagaFactory('createPartner', actions.createPartner, callApi.createPartner, 'createPartner');
export var createPartnerAttribute = sagaFactory('createPartnerAttribute', actions.createPartnerAttribute, callApi.createPartnerAttribute, 'createPartnerAttribute');
export var updatePartnerAttribute = sagaFactory('updatePartnerAttribute', actions.updatePartnerAttribute, callApi.updatePartnerAttribute, 'updatePartnerAttribute');
export var deletePartnerAttribute = sagaFactory('deletePartnerAttribute', actions.deletePartnerAttribute, callApi.deletePartnerAttribute, 'deletePartnerAttribute');
export var createPartnerPrice = sagaFactory('createPartnerPrice', actions.createPartnerPrice, callApi.createPartnerPrice, 'createPartnerPrice');
export var updatePartnerPrice = sagaFactory('updatePartnerPrice', actions.updatePartnerPrice, callApi.updatePartnerPrice, 'updatePartnerPrice');
export var deletePartnerPrice = sagaFactory('deletePartnerPrice', actions.deletePartnerPrice, callApi.deletePartnerPrice, 'deletePartnerPrice');
export var createUserForPartner = sagaFactory('createUserForPartner', actions.createUserForPartner, callApi.createUserForPartner, 'addUserToPartner');
export var deleteUserFromPartner = sagaFactory('deleteUserFromPartner', actions.deleteUserFromPartner, callApi.deleteUserFromPartner, 'deleteUserFromPartner');
export var getPackageServiceTypes = sagaFactory('getPackageServiceTypes', actions.getPackageServiceTypes, callApi.getPackageServiceTypes, 'packageServiceTypes');
export var addUserToDriver = sagaFactory('addUserToDriver', actions.addUserToDriver, callApi.addUserToDriver, 'addUserToDriver');
export var executeRoutePricing = sagaFactory('executeRoutePricing', actions.executeRoutePricing, callApi.executeRoutePricing, 'calculateRoutePricing');
export var createPolybags = sagaFactory('createPolybags', actions.createPolybags, callApi.createPolybags, 'createPolybags');
export var createRouteEntitlements = sagaFactory('createRouteEntitlements', actions.createRouteEntitlements, callApi.createRouteEntitlements, 'createRouteEntitlements');
function adminSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(actions.getTrips.type.REQUEST, getTrips)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.getRoutes.type.REQUEST, getRoutes)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.getRoute.type.REQUEST, getRoute)];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.modifyRoute.type.REQUEST, modifyRoute)];
            case 4:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.createDriverReliability.type.REQUEST, createDriverReliability)];
            case 5:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.getTripsPage.type.REQUEST, getTripsPage)];
            case 6:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.getAuditsPage.type.REQUEST, getAuditsPage)];
            case 7:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.getDashboardData.type.REQUEST, getDashboardData)];
            case 8:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.getUsers.type.REQUEST, getUsers)];
            case 9:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.getUserRole.type.REQUEST, getRole)];
            case 10:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.updateUserRole.type.REQUEST, updateRole)];
            case 11:
                _a.sent();
                return [4 /*yield*/, takeLeading(actions.updateTrip.type.REQUEST, updateTrip)];
            case 12:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.deletePickup.type.REQUEST, deletePickup)];
            case 13:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.processScan.type.REQUEST, processScan)];
            case 14:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.deleteScan.type.REQUEST, deleteScan)];
            case 15:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.processQRCodeScan.type.REQUEST, processQRCodeScan)];
            case 16:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getCarriers.type.REQUEST, getCarriers)];
            case 17:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getRetailers.type.REQUEST, getRetailers)];
            case 18:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.createRetailer.type.REQUEST, createRetailer)];
            case 19:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.sendComms.type.REQUEST, sendComms)];
            case 20:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.createTripMedia.type.REQUEST, createTripMedia)];
            case 21:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.deleteTripMedia.type.REQUEST, deleteTripMedia)];
            case 22:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getPartners.type.REQUEST, getPartners)];
            case 23:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.createPartnerUser.type.REQUEST, createPartnerUser)];
            case 24:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getTripSummary.type.REQUEST, getTripSummary)];
            case 25:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getPackageSummary.type.REQUEST, getPackageSummary)];
            case 26:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.getOnfleetWorkers.type.REQUEST, getOnfleetWorkers)];
            case 27:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.getOnfleetWorkersForRoutes.type.REQUEST, getOnfleetWorkersForRoutes)];
            case 28:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.removeUserHub.type.REQUEST, removeUserHub)];
            case 29:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.addUserToHub.type.REQUEST, addUserToHub)];
            case 30:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.togglePartner.type.REQUEST, togglePartner)];
            case 31:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.updatePartner.type.REQUEST, updatePartner)];
            case 32:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.createPartner.type.REQUEST, createPartner)];
            case 33:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.createPartnerAttribute.type.REQUEST, createPartnerAttribute)];
            case 34:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.updatePartnerAttribute.type.REQUEST, updatePartnerAttribute)];
            case 35:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.deletePartnerAttribute.type.REQUEST, deletePartnerAttribute)];
            case 36:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.createPartnerPrice.type.REQUEST, createPartnerPrice)];
            case 37:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.updatePartnerPrice.type.REQUEST, updatePartnerPrice)];
            case 38:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.deletePartnerPrice.type.REQUEST, deletePartnerPrice)];
            case 39:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.createUserForPartner.type.REQUEST, createUserForPartner)];
            case 40:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.deleteUserFromPartner.type.REQUEST, deleteUserFromPartner)];
            case 41:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getPackageServiceTypes.type.REQUEST, getPackageServiceTypes)];
            case 42:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.addUserToDriver.type.REQUEST, addUserToDriver)];
            case 43:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.executeRoutePricing.type.REQUEST, executeRoutePricing)];
            case 44:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.createPolybags.type.REQUEST, createPolybags)];
            case 45:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.processPolybagScan.type.REQUEST, processPolybagScan)];
            case 46:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getUsersForSavers.type.REQUEST, getUsersForSavers)];
            case 47:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getPartnersForSavers.type.REQUEST, getPartnersForSavers)];
            case 48:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getDummyDriversByHubId.type.REQUEST, getDummyDriversByHubId)];
            case 49:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getAddressValidationFeedback.type.REQUEST, getAddressValidationFeedback)];
            case 50:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.getDrivers.type.REQUEST, getDrivers)];
            case 51:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.createRouteEntitlements.type.REQUEST, createRouteEntitlements)];
            case 52:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default adminSaga;
//# sourceMappingURL=admin.js.map